var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "./di/serviceLocator";
import { useSelector } from "react-redux";
var AssignLead = function (props) {
    var _a = __read(React.useState(), 2), previousOwnerDetails = _a[0], setPreviousOwnerDetails = _a[1];
    var _b = __read(React.useState(false), 2), openDetails = _b[0], setOpendetails = _b[1];
    var _c = __read(React.useState(), 2), selecatedEmp = _c[0], setselecatedEmp = _c[1];
    var _d = __read(React.useState(""), 2), searchEmp = _d[0], setSearchEmp = _d[1];
    var employeeList = useSelector(function (state) { var _a; return (_a = state.Lead.EmployeeList) === null || _a === void 0 ? void 0 : _a.employeeListEntity; });
    React.useEffect(function () {
        var _a;
        if (employeeList && ((_a = employeeList === null || employeeList === void 0 ? void 0 : employeeList.employeeListEntity) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            employeeList.employeeListEntity = employeeList.employeeListEntity.filter(function (record) {
                !!previousOwnerDetails &&
                    record.id !== previousOwnerDetails.leadOwnerCode
                    ? previousOwnerDetails.leadOwnerCode
                    : "";
            });
        }
    }, [employeeList]);
    var callEmpSearch = function (emp) {
        var payload = {
            searchText: emp,
            pageno: 1,
            pageSize: 10,
        };
        di.leads.getEmployeeList(payload);
    };
    var onEmpSearch = function (e) {
        setSearchEmp(e);
        props.isSearchEmp(e);
        if (!!Number(e)) {
            callEmpSearch(e);
        }
        else if (e.toString().length >= 3) {
            callEmpSearch(e);
        }
    };
    React.useEffect(function () {
        if (props.leadOwnerCode && props.leadOwnerName)
            setPreviousOwnerDetails({
                leadOwnerCode: props.leadOwnerCode,
                leadOwnerName: props.leadOwnerName,
            });
    }, [props.leadOwnerCode && props.leadOwnerName]);
    var setEmpDetailsProp = function (data) {
        props.passEMPData(data);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex justify-content-between assign-lead-body" },
            React.createElement("div", { className: "txt_black-seven DMSans_16_500" },
                "Current Lead Owner :\u00A0",
                React.createElement("label", { className: "txt_blackOne1" }, previousOwnerDetails === null || previousOwnerDetails === void 0 ? void 0 : previousOwnerDetails.leadOwnerName))),
        React.createElement("div", { className: "DMSanN_16_400 txt_blue-tint search-rm" },
            "Search RM",
            React.createElement(InputField, { placeholderClassName: "", placeholder: "Search By Name Or E-Code", onChange: function (e) {
                    onEmpSearch(e);
                }, id: "search-rm", name: "search-rm", required: false, autoComplete: "off", showLabel: false, className: "pt-1 search-RM-txtbox", onFocus: function () { return setOpendetails(true); }, value: "", defaultValue: (selecatedEmp === null || selecatedEmp === void 0 ? void 0 : selecatedEmp.name) || searchEmp }),
            (!!(selecatedEmp === null || selecatedEmp === void 0 ? void 0 : selecatedEmp.name) || !!searchEmp) &&
                openDetails &&
                (employeeList === null || employeeList === void 0 ? void 0 : employeeList.employeeListEntity) &&
                (employeeList === null || employeeList === void 0 ? void 0 : employeeList.employeeListEntity.length) > 0 && (React.createElement("div", { className: "search-data-table commonscroll-new" }, employeeList === null || employeeList === void 0 ? void 0 : employeeList.employeeListEntity.filter(function (record) { return record.id !== (previousOwnerDetails === null || previousOwnerDetails === void 0 ? void 0 : previousOwnerDetails.leadOwnerCode); }).map(function (data) {
                return (React.createElement("div", { className: "d-flex justify-content-between", onClick: function () {
                        setselecatedEmp(data);
                        setEmpDetailsProp(data);
                        setOpendetails(!openDetails);
                    } },
                    React.createElement("div", { className: "DMSans_16_500 txt_blackOne1" }, data.name)));
            }))))));
};
export default AssignLead;
